import React from "react";
import { Box } from "@mui/material";
import { ColletteChip } from "@collette-travel/collette-common-controls";

interface DestinationData {
  id: string;
  name: string;
  slug: string;
  destinationUrl: string;
  destinationType?: string | null;
}

interface DestinationChipsProps {
  destinations: DestinationData[];
}

const DestinationChips: React.FC<DestinationChipsProps> = ({ 
  destinations
}) => (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "12px",
        mt: 3,
        maxWidth: "100%",
        // Ensure chips have consistent spacing when they wrap
        rowGap: "16px",
        columnGap: "12px"
      }}
    >
      {destinations.map((destination) => (
            <ColletteChip
              key={destination.slug}
              label={destination.name}
              testId={`destination-chip-${destination.destinationType ? destination.destinationType.replace("destination", "").toLowerCase() : "continent"}-${destination.slug}`}
              size="medium"
              variant="filled"
              color="secondary"
              {...({
                component: "a",
                href: destination.destinationUrl,
                "data-track": "click"
              } as any)}
              sx={{
                cursor: "pointer",
                textDecoration: "none",
                backgroundColor: "background.cool_strong",
                color: "text.primary",
                fontSize: "14px",
                fontWeight: 500,
                letterSpacing: "0.4px",
                lineHeight: "14.63px",
                padding: "8px 16px",
                borderRadius: "20px",
                border: "none",
                "&:hover": {
                  textDecoration: "none",
                  backgroundColor: "background.cool",
                  transform: "translateY(-1px)"
                }
              }}
            />
      ))}
    </Box>
  );

export default DestinationChips;